export default function engineerRun($transitions, ngDialog) {
  'ngInject';

  $transitions.onSuccess({}, () => ngDialog.closeAll());
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/engineer.run.js